import { Alert, Snackbar } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPGState } from "../productGroupSetupSlice";

const alertFontSize = "15px";

export default function CreateMessage() {
	const pgState = useSelector((store) => store.productGroupSetup);
	const { createMessage, createMessageSeverity, createMessageOpen } = pgState;
	const dispatch = useDispatch();
	const handleCloseSnackbar = () => {
		dispatch(setPGState("createMessageOpen", false));
		dispatch(setPGState("createMessage", ""));
		dispatch(setPGState("createMessageSeverity", ""));
	};

	return (
		<Snackbar
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			open={createMessageOpen}
			autoHideDuration={5000}
			onClose={handleCloseSnackbar}
		>
			<Alert
				onClose={handleCloseSnackbar}
				severity={createMessageSeverity}
				sx={{ width: "100%", fontSize: alertFontSize }}
			>
				{createMessage}
			</Alert>
		</Snackbar>
	);
}
